import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["exclusionDate", "statusSelection"]

  connect() {
    this.onSelectionChange()
  }

  onSelectionChange(e) {
    if (e != undefined)
      e.preventDefault()
    this.toggleExclusionDateField(this.statusSelectionTarget.selectedOptions[0].value == 'Ingen')
  }

  toggleExclusionDateField(showExclusionDate) {
    if (showExclusionDate) {
      if (this.exclusionDateTarget.classList.contains('hidden')) {
        this.exclusionDateTarget.classList.toggle('hidden')
      }
    } else {
      if (!this.exclusionDateTarget.classList.contains('hidden')) {
        this.exclusionDateTarget.classList.toggle('hidden')
      }
    }
  }
}